import { SearchFilterListComponent } from './search-filter-list.component';

export default angular
  .module('sfMobile.components.search-filter-list', [
    'sfMobile.components.chip',
    'sfMobile.components.scroll-horizontal',
  ])
  .component('sfSearchFilterList', SearchFilterListComponent).name;
